import React from 'react'
import { Box } from '@mui/material'
import { usePostExportEndUserAppleLuckyDraw } from '../../../../api/promotions/end-user/end-user-apple-lucky-draw'
import SearchParam from '../../../shared/SearchParam'
import ExportButton from '../../../shared/ExportButton'

const Toolbar = () => {
  const exportApi = usePostExportEndUserAppleLuckyDraw()

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' m={1} gap={4}>
      <SearchParam param='name' placeholder='Search by name...' />
      <ExportButton
        exportApi={exportApi}
        fileLabel={'promotions_end_user_apple_products_lucky_draw'}
      />
    </Box>
  )
}

export default Toolbar
